import {
  FETCH_ALL_PRODUCTS,
  FETCH_ALL_PRODUCTS_SUCCESS,
  FETCH_ALL_PRODUCTS_FAILED
} from '../../types';

const initialState = {
  products: {},
  isLoading: false,
  errors: {},
  error: false
}

const fetchProductsReducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_ALL_PRODUCTS:
      return {
        ...state,
        isLoading: true,
          products: action.payload
      }
      case FETCH_ALL_PRODUCTS_SUCCESS:
        return {
          ...state,
          isLoading: false,
            products: action.payload
        }
        case FETCH_ALL_PRODUCTS_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchProductsReducer;
